import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';
import { MeterDetails } from '../data/MeterDetails';
import { startOfTomorrow } from 'date-fns';

export const useMetersStore = defineStore('meters', {
  state: () => ({
    meters: useLocalStorage(
      'meters',
      // name, peak_in_watt, id
      null,
    ),
    selectedMeter: useLocalStorage('selectedMeter', null),
    meterDetails: useLocalStorage('meterDetails', null),
  }),
  getters: {
    getMeters(state) {
      return JSON.parse(state.meters);
    },
    getSelectedMeter(state) {
      return JSON.parse(state.selectedMeter);
    },
    getMeterDetails(state): MeterDetails {
      const withMetaData = JSON.parse(state.meterDetails);

      // temporary 2025-07-07
      if (!withMetaData || !withMetaData.data) {
        return withMetaData;
      }

      return withMetaData.data;
    },
  },
  actions: {
    set(meters) {
      this.meters = JSON.stringify(meters);
    },
    setSelected(meter) {
      this.selectedMeter = JSON.stringify(meter);
    },
    setMeterDetails(meterDetails: object) {
      const withMetaData = {
        data: meterDetails,
        meta: {
          expiresAt: startOfTomorrow(),
        },
      };
      this.meterDetails = JSON.stringify(withMetaData);
    },
    meterDetailsExpired(): boolean {
      const withMetaData = JSON.parse(this.meterDetails);

      return (
        !withMetaData ||
        !withMetaData.meta ||
        !withMetaData.meta.expiresAt ||
        new Date(withMetaData.meta.expiresAt) < new Date()
      );
    },
    meterDetailsInvalid(): boolean {
      const withMetaData: any = JSON.parse(this.meterDetails);
      const invalid: boolean = !withMetaData.data.id || !withMetaData.data.plant_id;

      if (invalid) {
        this.clearSelectedMeter();
      }

      return invalid;
    },
    clearSelectedMeter() {
      this.selectedMeter = null;
      this.meterDetails = null;
    },
    clearAll() {
      this.meters = null;
      this.clearSelectedMeter();
    },
  },
});
